// @flow
import { themeStyle } from '../colorPalettes'

import { darkTheme } from './darkTheme'

import type { ThemeType } from '..'

const signisplayThemeName = 'signisplay'

export const themeSignisplay: ThemeType = {
  name: signisplayThemeName,
  getThemeVariation: (themeVariation: string) => {
    switch (themeVariation) {
      case themeStyle.dark:
        return darkTheme
      default:
        return darkTheme
    }
  },
}
